<template>

    <LoopItemPanel title="Item">

        <div class="canvas-blocks-custom-weekAgenda-admin-LoopItemPanel">

            <Tabs :tabs="[
                'Algemeen',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Leeg vlak?"
                        instruction="Bepaal hier of het een leeg vlak moet zijn."
                        :options="loopItem"
                        options-property="emptySpace"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                        :open="true"
                    />


                    <ColorsInput
                        label="Achtergrondkleur"
                        instruction="Bepaal hier de achtergrondkleur van het blokje."
                        :colors="colors"
                        :options="loopItem"
                        options-property="color"
                    />

                    <ColorsInput
                        label="Tekstkleur"
                        instruction="Bepaal hier de kleur van de tekst van de button."
                        :colors="colors"
                        :options="loopItem"
                        options-property="textColor"
                    />

                </div>

            </Tabs>

        </div>

        <template v-slot:actionsExtra>
            <button class="btn btn-success" @click="save">
                <i class="mr-2 fas fa-check"></i> Opslaan
            </button>
        </template>

    </LoopItemPanel>

</template>

<script>

import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AccordionInput from '@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input';
import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopItemPanel";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: LoopItemPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        AccordionInput,
        LoopItemPanel,
        ColorsInput,
        SwitchInput,
    },

    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors()).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);
        },

    },

}
</script>
